import * as React from 'react';
import Flex from '../../../components/Flex';
import FormField from '../../../components/FormField';
import TextField, {TextFieldProps} from '../../../components/TextField';
import {PillButton} from '../../../components/Button';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {FormikProps} from 'formik';

export interface FormValues {
  email: string;
  password: string;
}

interface LoginFormBaseProps extends FormikProps<FormValues> {
  isLoading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

export default class LoginFormBase extends React.Component<LoginFormBaseProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, handleSubmit, isLoading} = this.props;

    const commonFieldProps: TextFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      large: true,
      iconPosition: 'end'
    };

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="Email">
          <TextField
            type="email"
            id="email"
            value={values.email}
            icon={!errors.email && touched.email && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.email && touched.email)}>{errors.email}</ErrorMessage>
        </FormField>
        <FormField label="Password">
          <TextField
            type="password"
            id="password"
            value={values.password}
            icon={!errors.password && touched.password && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.password && touched.password)}>{errors.password}</ErrorMessage>
        </FormField>
        <Flex center={true}>
          <PillButton type="submit" variant="primary" loading={isLoading} large={true} style={{marginBottom: 100}}>
            Login
          </PillButton>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/AirbnbLoginForm/private/AirbnbLoginFormBase.tsx